import React from "react";
import { Switch, Route } from "react-router-dom";
import SmartDispatching from "./Index";

export default () => (
    <Switch>
        <Route exact path="/smartdispatching" component={SmartDispatching} />
    </Switch>
);
